let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bD36u")).then(() => parcelRequire('iBmSz'));